/* js/forminput.js */

jQuery( document ).ready(function( $ ) {

    $('.js-forminput').blur(function(){
        tmpval = $(this).val();
        if(tmpval == '') {
            $(this).addClass('forminput-empty');
            $(this).removeClass('forminput-not-empty');
        } else {
            $(this).addClass('forminput-not-empty');
            $(this).removeClass('forminput-empty');
        }
    });

});